import React, { Component } from 'react';
import './Prompt.css';

class Prompt extends Component {
    render() {
        return (
            <div className="toast-wrapper">
                <div className={"toast " + this.props.type + (this.props.visible ? " show" : " gone")}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Prompt;


// WEBPACK FOOTER //
// ./src/Prompt.js